import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

interface CustomTooltipProps extends Omit<TooltipProps, 'title'> {
  children: any;
  label: string;
  customStyles?: {
    tooltip?: React.CSSProperties;
    arrow?: React.CSSProperties;
  };
  tooltipWidth?: string | number;
  tooltipHeight?: string | number;
}

const StyledTooltip = styled(
  ({
    className,
    customStyles,
    label,
    tooltipWidth,
    tooltipHeight,
    ...props
  }: CustomTooltipProps) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      title={label}
      arrow
      componentsProps={{
        tooltip: {
          sx: {
            // Only apply specific width/height if content is long
            ...(label && label.length > 200
              ? {
                  maxWidth: tooltipWidth || 'none',
                  width: tooltipWidth,
                  maxHeight: tooltipHeight || 'none',
                  overflowY: 'auto',
                }
              : {}),
            overflowWrap: 'break-word',
            wordWrap: 'break-word',
            whiteSpace: 'normal',
            ...customStyles?.tooltip,
          },
        },
      }}
    />
  )
)(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    // Default styling to prevent unnecessary scrolling for short text
    maxWidth: 'auto',
    width: 'auto',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
}));

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  label,
  children,
  customStyles,
  tooltipWidth,
  tooltipHeight,
  ...props
}) => {
  return (
    <StyledTooltip
      label={label}
      customStyles={customStyles}
      tooltipWidth={tooltipWidth}
      tooltipHeight={tooltipHeight}
      {...props}
    >
      {children}
    </StyledTooltip>
  );
};

export default CustomTooltip;
